import React from "react";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ArrowRight } from "@mui/icons-material";
import { arrowTypographyStyles } from "../style";
import DataTools from "../../../DataTools/DataTools";

const Description = () => {
  const displayedTool = DataTools.find((tool) => tool.id === parseInt(3));
  if (!displayedTool) {
    return <div>Tool not found</div>;
  }
  return (
    <Box >
      <Stack spacing={2} useFlexGap 
      // sx={{ width: { xs: "100%", sm: "100%" } }}
      >
        <Typography
          variant="h1"
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignSelf: "center",
            textAlign: "center",
            fontSize: "clamp(1rem, 10vw, 2rem)",
          }}
          // sx={arrowTypographyStyles}
        >
          Swellable Packer
        </Typography>
        <Typography variant="h3" sx={arrowTypographyStyles}>
          Tool Description
        </Typography>
        <Typography
          textAlign="start"
          color="text.secondary"
          sx={{ alignSelf: "start", width: { sm: "100%", md: "100%" } }}
          paragraph
        >
          The swellable packer is a permanent liquid swellable packer, which is
          divided into two types: oil swellable and water swellable.
          <br />
        </Typography>
        <Stack direction="row" spacing={1} alignItems="center" >
          <ArrowRight />
          <Typography>Pressure Grade: 5000psi</Typography>
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center">
          <ArrowRight />
          <Typography>Temperature Rating: 0—120°C</Typography>
        </Stack>
      </Stack>
      <Box
        sx={{
          width: "100%", // Set the width of the outer box
          //maxWidth: '140px', // Set the maximum width of the outer box
          display: "flex",
          justifyContent: "center", // Center the content horizontally
          flexWrap: "wrap", // Allow the content to wrap if needed
          //backgroundColor: 'green',

          mt: 2, // Add margin at the top
        }}
      >
        <img
          src={displayedTool.image}
          alt={`Swellable Packer Tool`}
          style={{
            width: "100%", // Set the width of the image
            maxWidth: "466px",
            height: "auto", // Automatically adjust the height based on the width
            // display: 'inline-block', // Ensure the image is displayed as an inline block
          }}
        />
      </Box>
    </Box>
  );
};

export default Description;
